import { render, staticRenderFns } from "./Skandia.vue?vue&type=template&id=7b225b58&scoped=true&"
import script from "./Skandia.vue?vue&type=script&lang=js&"
export * from "./Skandia.vue?vue&type=script&lang=js&"
import style0 from "./Skandia.vue?vue&type=style&index=0&id=7b225b58&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b225b58",
  null
  
)

export default component.exports